import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrProgressButtonDirective } from './tr-progress-button.directive';

@NgModule({
  imports: [ CommonModule ],
  exports: [ TrProgressButtonDirective ],
  declarations: [ TrProgressButtonDirective ],
})
export class TrProgressButtonDirectiveModule { }
